import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

import { Main } from './components/main';
import { domainMeta } from './utils/domainMeta';

export const Root = (): JSX.Element => {
  const isStaging = domainMeta.environment === 'stage';

  return (
    <Suspense fallback={<div />}>
      <Switch>
        {/* Privacy routes — listed first so /privacy isn't matched as a brandId */}
        {isStaging && (
          <Route
            exact
            path="/:commitHash([0-9a-f]{7})/:accountSlug/:brandId/privacy"
            component={Main}
          />
        )}
        {isStaging && (
          <Route
            exact
            path="/:commitHash([0-9a-f]{7})/:accountSlug/privacy"
            component={Main}
          />
        )}
        <Route exact path="/:accountSlug/:brandId/privacy" component={Main} />
        <Route exact path="/:accountSlug/privacy" component={Main} />

        {/* Routes with commit hash - more specific route first - ONLY ON STAGE ENVS */}
        {isStaging && (
          <Route
            path="/:commitHash([0-9a-f]{7})/:accountSlug/:brandId?"
            component={Main}
          />
        )}

        {/* Routes without commit hash */}
        <Route path="/:accountSlug/:brandId?" component={Main} />
      </Switch>
    </Suspense>
  );
};
